<i18n>
en:
  complete:
    msg: "A password reset link has been sent to your registered E-mail."
  mail:
    label: "E-mail"
  explanation:
    text1: |-
      Please enter your registered E-mail.<br>
      Send a password reset link.
    text2:
      before: "If you have forgotten your E-mail, please"
      label: "contact"
      after: "us from the inquiry."
  submit: "Send"
ja:
  complete:
    msg: "ご登録のメールアドレスにパスワード再設定リンクを送信しました"
  mail:
    label: "メールアドレス"
  explanation:
    text1: |-
      登録したメールアドレスを入力してください。<br>
      パスワード再設定のリンクを送信します。
    text2:
      before: "メールアドレスを忘れた場合"
      label: "お問い合わせ"
      after: "からご連絡ください。"
  submit: "送信する"
</i18n>

<template lang="pug">
  div.my-6
    v-container
      //- 正常終了
      template(v-if="isComplete")
        v-row
          v-col.mb-12.pb-12(cols="12" align="center")
            v-alert(dense outlined prominent type="success" border="bottom")
              div(v-html="$t('complete.msg')")

      //- 入力フォーム
      template(v-else)
        v-form(onsubmit="return false" v-model="valid")
          v-row(justify="center")
            v-col(cols="12" sm="6" md="4" xl="2")
              v-text-field(prepend-icon="fa-envelope" :label="$t('mail.label')" :rules="v($t('mail.label'), ['required', 'mail'])" v-model="forms.mailAddress")

          v-row
            v-col.red--text(cols="12" align="center")
              v-sheet.d-inline-flex(color="transparent" align="left")
                ul
                  li(v-html="$t('explanation.text1')")
                  li
                    |{{$t('explanation.text2.before')}}&nbsp;
                    strong
                      a(href="#" :to="{name: 'PassForget'}")|{{$t('explanation.text2.label')}}
                    |&nbsp;{{$t('explanation.text2.after')}}

          //- 送信ボタン
          v-row(justify="center")
            v-col(cols="12" sm="6" md="4" xl="2")
              v-btn(x-large block color="primary" type="submit" @click="submit" :loading="isSubmit" :disabled="!valid")|{{$t('submit')}}

          //- エラーメッセージ
          v-row(v-if="errMsg")
            v-col(cols="12" align="center")
              v-alert.d-inline-block(dense outlined type="error")
                div(v-html="errMsg")
</template>

<script>
export default {
  data () {
    return {
      // 入力フォーム
      forms: {
        mailAddress: null
      },
      // 入力バリデーション
      valid: false,
      // 送信中
      isSubmit: false,
      // 完了
      isComplete: false,
      // エラーメッセージ
      errMsg: null
    }
  },
  methods: {
    /**
     * 送信
     */
    submit () {
      if (this.isSubmit) {
        return
      }

      this.isSubmit = true
      this.isComplete = false
      this.errMsg = null

      this.api.passForget({
        mailAddress: this.forms.mailAddress
      })
        .then(response => {
          this.isComplete = true
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
        .finally(() => {
          this.isSubmit = false
        })
    }
  }
}
</script>

<style lang="sass" scoped>
</style>
